<template>
    <div class="story-maker-sticker story-maker-sticker-music" :class="{edit : isEditing}">
        <audio @canplaythrough="(e) => e.target.volume = '0.5'" :src="music.track.progressive_download_url" :ref="`music-preview`"></audio>
        <img class="img-change-color" :src="require('../../../../../assets/img/instagram/ehf.png')">
        <p class="text-finish" @click="finish">Terminé</p>
        <i class="fa-solid fa-trash trash" @click="deleteMusic"></i>
        <div class="container-options" v-if="isEditing">
            <div class="options">
                <div class="circle btn-time">
                    <select class="timer-music" v-model="models.rangeDuration" @change="playMusic">
                        <option value="5000">5</option>
                        <option value="6000">6</option>
                        <option value="7000">7</option>
                        <option value="8000">8</option>
                        <option value="9000">9</option>
                        <option value="10000">10</option>
                        <option value="11000">11</option>
                        <option value="12000">12</option>
                        <option value="13000">13</option>
                        <option value="14000">14</option>
                        <option value="15000">15</option>
                    </select>
                </div>
                <div class="container-line">
                    <div class="repair" :style="{left : `${time / music.track.duration_in_ms * 100}%`}" v-for="time in music.track.highlight_start_times_in_ms" @click="clickRepair(time)"></div>
                    <div class="range" :style="{
                        width : `${parseInt(models.rangeDuration) / music.track.duration_in_ms * 100}%`,
                        left : `${models.start / music.track.duration_in_ms * 100}%`
                    }" ></div>
                </div>
                <div class="circle btn-play" :class="{playing: isPlaying}" @click="toogleMusic"></div>
            </div>
            <div class="timeline">
                <div class="box"><div class="progress" :style="isPlaying && duration >= 0 ? `width: ${100 - (duration / parseInt(models.rangeDuration) * 100)}%;`: ''"></div></div>
                <div class="bars hide-scrollbar" @scroll="handleScroll" ref="scrollContainer">
                   
                    <div class="bar" :class="{high: index%2 == 0}" v-for="(bar, index) in Array.from({length: parseInt(music.track.duration_in_ms / 1000)})"></div>
                </div>
            </div>
        </div>
        <!-- <div class="sticker-music">
           <div class="icon"></div>
            {{ music.track.title ? music.track.title : '' }}
        </div> -->
    </div>
</template>

<script>

    export default {
        props: {
            id: Number | String,
            music: Object,
            isEditing: Boolean,
            isPreventCover: Boolean,
            isCover: Boolean,
            setCover: Function,
            setCbClick: Function,
        },
        
        data() {
            return {
                timeoutFinish: null,
                models : {
                    rangeDuration: '15000',
                    start: 0,
                },
                isPlaying: false,
                timeOutRepeatRange: null,
                intervalRange: null,
                duration: 0
                
            }
        },

        mounted () {
            if (this.isEditing) this.playMusic()
        },
  
        methods: {
            clickSticker() {
                if (this.isEditing) return 
                this.setCover(true)
                this.$nextTick(()=> {
                    this.$emit('updateSticker',this.id , {
                        isEditing: true
                    })   
                })
            },

            finish() {
                this.$emit('updateSticker',this.id , {
                    isEditing: false,
                    disableTransform: true,
                    disableMove: true,

                    data: {
                        music: this.music,
                        rangeDuration: parseInt(this.models.rangeDuration),
                        start: this.models.start
                    }
                })
                this.pauseMusic()

                if (this.timeoutFinish) clearTimeout(this.timeoutFinish)
                this.timeoutFinish = setTimeout(() => {
                    this.setCover(false)
                }, 200);
            },

            deleteMusic() {
                this.$emit('deleteSticker',this.id)
            },

            handleScroll(event) {
                const element = event.target; 
                const scrollPercentage = (element.scrollLeft / (element.scrollWidth - element.clientWidth))
                this.models.start = Math.round(this.music.track.duration_in_ms * scrollPercentage - parseInt(this.models.rangeDuration) * scrollPercentage)
                this.playMusic()
            },

            clickRepair(timeMs) {
                this.models.start = timeMs;
                const scrollPercentage = timeMs / (this.music.track.duration_in_ms - parseInt(this.models.rangeDuration))
                this.$refs.scrollContainer.scrollLeft = (this.$refs.scrollContainer.scrollWidth - this.$refs.scrollContainer.clientWidth) * scrollPercentage;
                this.playMusic()
            },

            playMusic() {
                if (this.timeOutRepeatRange) clearTimeout(this.timeOutRepeatRange)
                if (this.intervalRange) clearInterval(this.intervalRange)
                this.duration = 0


                let audio = this.$refs['music-preview'];
                if (document.contains(audio)) {
                    this.isPlaying = true
                    audio.currentTime = this.models.start / 1000;
                    audio.play();
    
                    this.timeOutRepeatRange = setTimeout(() => {
                        if (this.intervalRange) clearInterval(this.intervalRange)
                        this.playMusic()
                    }, this.models.rangeDuration);
    
                    this.intervalRange = setInterval(()=> {
                        this.duration = this.duration + 100
                    },100)
                }
             
            },

            pauseMusic() {
                this.duration = 0
                if (this.timeOutRepeatRange) clearTimeout(this.timeOutRepeatRange)
                if (this.intervalRange) clearInterval(this.intervalRange)

                let audio = this.$refs['music-preview']
                audio.pause();
            },

            toogleMusic() {
                let audio = this.$refs['music-preview'];
                this.isPlaying = audio.paused
                if (audio.paused) {
                    this.playMusic()
                } else {
                    if (this.timeOutRepeatRange) clearTimeout(this.timeOutRepeatRange)
                    if (this.intervalRange) clearInterval(this.intervalRange)
                    audio.pause();
                }
            },

            

            destroyed () {
                if (this.timeOutRepeatRange) clearTimeout(this.timeOutRepeatRange)
                if (this.intervalRange) clearInterval(this.intervalRange)
            },
        },

        watch: {
            isEditing: {
            handler(newValue) {
                if (newValue && !this.isPreventCover && !this.isCover) {
                    this.isEditing = false
                    this.clickSticker()
                }
            },
            immediate: true
        },
        },

    }
</script>
